/**
 * Checks if a string contains HTML tags.
 * @param {String} str
 * @returns {Boolean}
 */
export function isHtmlString(str) {
  return typeof str === 'string' && /<[a-z][\s\S]*?>/i.test(str)
}

/**
 * Extracts inner text from HTML string using regex, replacing text chunks with placeholders.
 * Returns the template HTML with placeholders like __TEXT_0__, __TEXT_1__ and array of text objects.
 *
 * @param {String} htmlString
 * @returns {Object} { isHtml: boolean, template: string, texts: Array }
 */
export function extractHtmlInnerText(htmlString) {
  if (!isHtmlString(htmlString)) {
    return { isHtml: false, template: htmlString, texts: [] }
  }

  const parts = htmlString.split(/(<[^>]+>)/g)
  const texts = []

  const templateParts = parts.map((part) => {
    if (!part) return ''
    if (part.startsWith('<') && part.endsWith('>')) {
      return part
    }

    const match = part.match(/^(\s*)([\s\S]*?)(\s*)$/)
    const leading = match ? match[1] : ''
    const coreText = match ? match[2] : ''
    const trailing = match ? match[3] : ''

    if (!coreText) {
      return part
    }

    const index = texts.length
    texts.push({
      index,
      leading,
      text: coreText,
      trailing
    })

    return `${leading}__TEXT_${index}__${trailing}`
  })

  return {
    isHtml: true,
    template: templateParts.join(''),
    texts
  }
}

/**
 * Replaces __TEXT_i__ placeholders in template with translated texts.
 *
 * @param {String} template
 * @param {Object} translatedTextsMap - { 0: "Hello", 1: "world" }
 * @returns {String}
 */
export function rebuildHtml(template, translatedTextsMap) {
  return template.replace(/__TEXT_(\d+)__/g, (match, indexStr) => {
    const index = parseInt(indexStr, 10)
    return translatedTextsMap[index] !== undefined ? translatedTextsMap[index] : match
  })
}
